module.exports = __webpack_public_path__ + "static/media/Articles_Hero_Tablet_1.df9564de.png";